<template>
  <div class="hp-manager-page-list">
    <a-button type="primary" @click="multiSubmit()">确定</a-button>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" rowKey="organizationId" :indentSize="15" :dataSource="datas" :pagination="false" :loading="loading" @tableChange="tableChange" :rowSelection="rowSelection">
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  name: "hp-manager-page-productOrg-add",
  mixins: [account, dateFormat, moneyFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [],
      columns: [
        {
          title: "销售组织",
          dataIndex: "organizationName",
          sorter: true
        },
        {
          title: "组织代码",
          dataIndex: "organizationCode",
          width: 200,
          sorter: true
        },
        {
          title: "组织形态",
          dataIndex: "organizationTypeName",
          width: 200
        }
      ],
      datas: [],
      filterdata: Object.assign(JSON.parse(JSON.stringify(config.pageFilter))),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      rowSelection: null,
      selectedIdList: [],
      productId: 0
    };
  },
  async mounted() {
    this.productId = this.paramsX.id;
    this.rowSelection = {
      onChange: this.onSelectChange,
      getCheckboxProps: this.getCheckboxProps
    };
    this.getDatas();
  },
  methods: {
    handleSubmit(p) {
      this.getDatas();
    },
    async multiSubmit() {
      let orgIds = [];
      this.selectedRows.forEach((element, index) => {
        orgIds.push(element.organizationId);
      });
      let request = { productId: this.productId, organizationIds: orgIds };
      let msgRet = await api.UpdateBomProductOrganization(request);
      if (msgRet) {
        this.$message.success("修改成功");
        this.$emit("submit-success");
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRows);
      this.selectedRows = selectedRows;
      this.rowSelection = {
        selectedRows: selectedRows,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };
    },
    getCheckboxProps(record) {
      return {
        props: {
          defaultChecked: record.isChecked
        }
      };
    },
    refreshCurrent() {
      this.getDatas();
    },
    tableChange(table) {
      this.getDatas();
    },

    async getDatas() {
      this.loading = true;
      let data = await api.GetProductOrganizationListForUpdate({
        productId: this.productId
      });
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/BomProduct/AddRelationOrg.vue